export default __webpack_public_path__ + "static/media/Kvalitet 2.cd1e3dfd.jpg";